import React from 'react';
import ContactStrip from 'components/contact-strip';
import { ButtonTag, ButtonTagWithLabel } from 'components/labels';
import { CreditCardBenefitsImg } from 'constants/explore-cc';
import styles from '../styles/CreditCardCovers.module.scss';

const CreditCardCovers = ({ active, benefits, ...creditCardInfo }) => {
  const benefit = benefits.find(R.propEq('name', active));
  const Icon = CreditCardBenefitsImg[active] || CreditCardBenefitsImg.default;

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.left}>
          <h3 className={styles.title}>
            <Icon className={styles.icon} />
            <span>{active}</span>
          </h3>
          <ButtonTagWithLabel
            tagClassName={styles.tag}
            label="Premium"
            text="Free"
          />
          <ButtonTagWithLabel
            tagClassName={styles.tag}
            label="Excess"
            text={benefit?.excess}
          />
        </div>
        <div className={styles.right}>
          <h3 className={styles.title}>Insurance benefits</h3>
          {benefit?.covers.map((c, idx) => (
            <ButtonTag className={styles.tag} key={`${c}_${idx}`} text={c} />
          ))}
        </div>
        <div className={styles.contacts}></div>
      </div>
      <ContactStrip className={styles.contacts} {...creditCardInfo} />
      <div className={styles.subText}>
        *Refer to your credit card insurance policy for latest information. Some
        credit cards require activation for insurance to be valid. Please check
        by visiting your provider’s website.
      </div>
    </div>
  );
};

export default CreditCardCovers;
